module.exports = __webpack_public_path__ + "img/Isabela.2e2da758.jpg";